module.exports = __webpack_public_path__ + "img/pleat depth hipline.987ca51e.png";